import React from "react";
import Icon from "@ant-design/icons";
import Icons from "assets/icons";
import {ColumnsEdit} from "types/models/column-table-edit";

export type DataTableMenu = {
  id: number;
  idDonThuoc: number;
  idThuoc: number;
  tenThuoc: string;
  donVi: number;
  soLuong: number;
  lieuDung: number;
  cachDung: number;
  hoatChat: string;
  ghiChu: string;
  donGia: number;
  thanhTien: number;
  coBaoHiem: boolean;
};

let dataTableMenu: Array<DataTableMenu> = [];

for (let index = 1; index < 10; index++) {
  const item: DataTableMenu = {
    id: index,
    idDonThuoc: index,
    idThuoc: -1,
    coBaoHiem: true,
    soLuong: 10,
    cachDung: -1,
    donGia: 7200,
    donVi: -1,
    ghiChu: "đơn thuốc",
    hoatChat: "111",
    lieuDung: 1,
    tenThuoc: "Thuốc trợ tim",
    thanhTien: 100000,
  };
  dataTableMenu.push(item);
}

const optionsLieuDung: any = [
  {
    label: "1 lần/ngày",
    value: 0,
  },
  {
    label: "2 lần/ngày",
    value: 1,
  },
  {
    label: "1 lần/ngày",
    value: 2,
  },
  {
    label: "Chọn liều dùng",
    value: -1,
  },
];
const listOptionMat = [
  {
    value: 0,
    label: "Mắt trái",
  },
  {
    value: 1,
    label: "Mắt phải",
  },
  {
    value: 2,
    label: "Hai mắt",
  },
  {
    value: 3,
    label: "Không xác định mắt",
  },
];
const columnsIcdTableMenu: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    align: "center",
    width: "3%",
    render: (v, r, i) => i + 1,
  },
  {
    key: 1,
    dataIndex: "maIcd",
    title: "Mã ICD",
    align: "left",
    width: "12%",
    type: "AUTO_COMPLETE",
  },
  {
    key: 2,
    dataIndex: "tenIcd",
    title: "Tên ICD",
    align: "left",
    editable: true,
    type: "AUTO_COMPLETE",
    width: "32%",
  },
  {
    key: 5,
    dataIndex: "mat",
    title: "Mắt",
    align: "left",
    editable: true,
    type: "COMBO_BOX",
    width: "12%",
  },
  {
    key: 3,
    title: "Chẩn đoán bổ sung",
    dataIndex: "ghiChu",
    editable: true,
    type: "INPUT",
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    width: "2%",
  },
];
const columnsBpTableMenu: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    align: "center",
    width: "3%",
    render: (v, r, i) => i + 1,
  },
  {
    key: 1,
    dataIndex: "maIcd",
    title: "Mã ICD",
    align: "left",
    width: "12%",
    type: "AUTO_COMPLETE",
  },
  {
    key: 2,
    dataIndex: "tenIcd",
    title: "Tên ICD",
    align: "left",
    editable: true,
    type: "AUTO_COMPLETE",
    width: "32%",
  },
  {
    key: 3,
    title: "Ghi chú",
    dataIndex: "ghiChu",
    editable: true,
    type: "INPUT",
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    width: "2%",
  },
];
export {
  columnsIcdTableMenu,
  columnsBpTableMenu,
  dataTableMenu,
  optionsLieuDung,
  listOptionMat,
};
